import React from 'react';
import { Link } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';

function TrendingTerm({term, filters, backRoute}) {
    const filtersParam  = encodeURIComponent(JSON.stringify(filters));
    const termParam     = encodeURIComponent(JSON.stringify(term));
    const backRouteParam = backRoute ? "?backRoute=" + backRoute : "";

    return (
        <tr>
            <td className="term">
                <Link to={`/trending-terms/${termParam}/${filtersParam}${backRouteParam}`}>
                    <FormattedMessage id={"pguidTranslation_" + term.indexTermPGUID} />
                </Link>
                <div className="tooltip arrow-top">
                    <FormattedMessage id={"pguidDescription_" + term.indexTermPGUID} />
                </div>
            </td>

            <td className="articles-number">
                <Link className="article-count" to={`/trending-terms/${termParam}/${filtersParam}${backRouteParam}`}>
                       {term.count}
                </Link>
            </td>

            <td className="risk-angles-levels">
                <div className="term-bullet-wrapper">
                    <span className="pestle-term">
                        <FormattedMessage id={"General_CoreFunctionality_UIText_general." + term.pestle} />
                    </span>
                    <span className={"risk-bullet " + term.riskLevel}>
                        <FormattedMessage id={"General_CoreFunctionality_UIText_general.risk." + term.riskLevel} />
                    </span>
                </div>
            </td>
        </tr>
    );
}

export default injectIntl(TrendingTerm);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/TrendingIndexTermPod/SingleTrendingTerm.jsx